// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1AEFf","rootSuccess":"CompleteLink_rootSuccess__2z4Fc","rootFailure":"CompleteLink_rootFailure__3d8Ve","isDisabled":"CompleteLink_isDisabled__3_UnY"};